import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { AvailableAreasApi } from '../../lib/apis/available-areas/available-areas-api';
import { AvailableArea } from './available-area';

@Injectable({ providedIn: 'root' })
export class AvailableAreasRepository {
  constructor(private readonly api: AvailableAreasApi) {}

  getAll(): Promise<AvailableArea[]> {
    return this.api
      .getAll()
      .pipe(take(1))
      .toPromise();
  }
}
